import {BaseClient} from "../../Api/HttpClient";
import toast from "react-hot-toast";
import {findAndRemoveFromArray} from "../../Utils/ArrayHelper";

export const createRegistrationSlice = (set, get) => ({
    registrations: [],
    registrationsMetaData: {},
    rejectedRegistrations: [],
    rejectedRegistrationsMetaData: {},

    getAllRegistrations: async (page = 1) => {
        await BaseClient().get('/freelancers/pending?page=' + page)
            .then(response => {
                if (response.status === 200) {
                    set({registrations: response.data.data})
                    set({registrationsMetaData: response.data.meta})
                } else {
                    toast.error(response.data);
                }
            })
    },
    getRejectedRegistrations: async (page = 1) => {
        await BaseClient().get('/rejected-freelancers?page=' + page)
            .then(response => {
                if (response.status === 200) {
                    set({rejectedRegistrations: response.data.data})
                    set({rejectedRegistrationsMetaData: response.data.meta})
                } else {
                    toast.error(response.data);
                }
            })
    },
    acceptRegistration: async (id,data) => {
        return await BaseClient().post(`/freelancers/${id}/approve`,data)
            .then(response => {
                if (response.status === 200) {
                    set({registrations: findAndRemoveFromArray(get().registrations, id)})
                    return true;
                } else {
                    return response.data;
                }
            })
    },
    acceptRejectedRegistration: async (id, data) => {
        return await BaseClient().post(`/rejected-freelancers/${id}/accept`, data)
            .then(response => {
                if (response.status === 200) {
                    set({rejectedRegistrations: findAndRemoveFromArray(get().rejectedRegistrations, id)})
                    return true;
                } else {
                    return response.data;
                }
            })
    },
    rejectRegistration: async (id, data) => {
        return await BaseClient().post(`/freelancers/${id}/decline`, data)
            .then(response => {
                if (response.status === 200) {
                    set({registrations: findAndRemoveFromArray(get().registrations, id)})
                    return true;
                } else {
                    console.log(response.data)
                    return false;
                }
            })
    },
    updateRejectionRemark: async (id, data) => {
        return await BaseClient().post(`/freelancers/${id}/rejection-remark`, data)
            .then(response => {
                if (response.status === 200) {
                    const updatedRejectedRegistrations = get().rejectedRegistrations.map(reg =>
                        reg.id === id ? {...reg, rejection_remark: data.rejection_remark} : reg
                    );
                    set({rejectedRegistrations: updatedRejectedRegistrations});
                    return true;
                } else {
                    return false;
                }
            })
    },
    forceDeleteRejectedFreelancer: async (id) => {
        return await BaseClient().delete(`/rejected-freelancers/${id}`)
            .then(response => {
                if (response.status === 200) {
                    set({rejectedRegistrations: findAndRemoveFromArray(get().rejectedRegistrations, id)})
                    return true;
                } else {
                    return response.data;
                }
            })
    }
})